import { jsx } from "react/jsx-runtime";
import PropTypes from "prop-types";
import { BadgeComponent } from "./badge.styles.es.js";
const propTypes = {
  count: PropTypes.number.isRequired,
  magnitude: PropTypes.oneOf(["small"])
};
const defaultProps = {
  magnitude: "small"
};
const Badge = ({ count, magnitude }) => {
  const size = {
    small: 16
  }[magnitude];
  const borderThickness = 1;
  return /* @__PURE__ */ jsx(BadgeComponent, { borderThickness, bigosity: size, children: count > 99 ? "⋯" : count });
};
Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
export {
  Badge
};
